if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadFirstPage() {
          // first page is rendered server-side; no-op to prevent design-mode error
        },
        loadData(url) {
          this.loading = true;
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response, 'text/html');
            const productGrid = html.getElementById('items-grid');
            // snapshot to a real array so indices stay stable across setTimeout calls
            const newProducts = Array.from(productGrid.getElementsByClassName('grid-item'));
            let productsOnPage = document.getElementById("items-grid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid; }
            newProducts.forEach((product, i) => {
              setTimeout(() => {
                // use outerHTML so the .grid-item wrapper is preserved
                const temp = document.createElement('div');
                temp.innerHTML = product.outerHTML;
                const el = temp.firstElementChild;
                productsOnPage.appendChild(el);
                // initialize Alpine directives (x-data, x-cloak, etc.) on the new card
                Alpine.initTree(el);
                if (i === newProducts.length - 1) {
                  this._renderButton(html);
                  this.loading = false;
                }
              }, i * 300);
            });
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
        },
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
            // re-initialize the new button's Alpine click handler
            Alpine.initTree(destination);
          }
        }
      }));
    });
  });
}
